import React, { useState, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import NavDropdown from 'react-bootstrap/NavDropdown'
import { Link } from 'react-router-dom'
import AddInquery from './AddInquery'
import { Divider, IconButton } from 'rsuite'
import EditIcon from '@rsuite/icons/Edit'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMoneyCheckDollar } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'

const Header = () => {
  const titleStyle = {
    color: 'white', // Change this to your desired title color
  }
  const [inqueriesActivity, setInqueriesActivity] = useState(false)
  const [currentCash, setCurrentCash] = useState(0)
  const url = process.env.REACT_APP_SERVER_URL

  useEffect(() => {
    getCurrentCash()
  }, [])

  const getCurrentCash = async () => {
    try {
      await axios.get(`${url}/currentCash`).then((response) => {
        setCurrentCash(response.data[0]['totalSum'])
      })
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <>
      <Navbar
        collapseOnSelect
        expand="sm"
        bg="black"
        style={{ color: 'white', padding: '0' }}
      >
        <Container
          expand="sm"
          style={{
            color: 'white',
            backgroundColor: 'black',
            fontSize: '16px',
            height: '4%',
          }}
        >
          <Navbar.Brand href="#home">
            <Link style={{ color: 'white',fontWeight:'bolder',marginRight:"6rem" }}>
            TIDY Inn
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            style={{ backgroundColor: 'white' }}
          />
          <Navbar.Collapse
            id="responsive-navbar-nav"
            style={{ color: 'white' }}
          >
            <Nav className="me-auto">
              <Nav.Link href="/tenants/add" style={{ color: 'white' }}>
                Checkin
              </Nav.Link>
              &nbsp;&nbsp;&nbsp;
              <Nav.Link href="/tenants" style={{ color: 'white' }}>
                Manage Guests
              </Nav.Link>
              &nbsp;&nbsp;&nbsp;
              <NavDropdown
                title={'Manage Rooms'}
                id="collapsible-nav-dropdown"
              >
                <NavDropdown.Item href="/rooms">Rooms</NavDropdown.Item>
                <NavDropdown.Item href="/repairs">Repairs</NavDropdown.Item>
                <NavDropdown.Item href="/amenities">Amenities</NavDropdown.Item>
                <NavDropdown.Item href="/cleaning">Cleaning</NavDropdown.Item>
                <NavDropdown.Item href="/tiles">Tile Calculator</NavDropdown.Item>

              </NavDropdown>
              <Nav.Link href="#pricing" style={{ color: 'white' }}></Nav.Link>
              <NavDropdown title={'Reports'} id="collapsible-nav-dropdown">
                {/* <NavDropdown.Item href="/roomAvailability">
                  Availability
                </NavDropdown.Item>
                <Divider /> */}
                <NavDropdown.Item href="/taxCalculations">
                  Taxation Report
                </NavDropdown.Item>
                <NavDropdown.Item href="/roomwisePayments">
                  Room Wise Payment Report
                </NavDropdown.Item>
                <NavDropdown.Item href="/activeTenants">
                  Missing Payments
                </NavDropdown.Item>
                <NavDropdown.Item href="/freeDaysReport">
                  Occupancy Report
                </NavDropdown.Item>
                <NavDropdown.Item href="/deposits">
                  Deposits Report
                </NavDropdown.Item>
                <NavDropdown.Item href="/cashCollectionReport">
                  Cash Collection Report
                </NavDropdown.Item>
                <NavDropdown.Item href="/templates">
                  Document Templates
                </NavDropdown.Item>
                
                <Divider />
                <NavDropdown.Item href="/payments">
                  Payments History
                </NavDropdown.Item>
                <NavDropdown.Item href="/tenantHistory">
                  Tenancy History
                </NavDropdown.Item>
                <NavDropdown.Item href="/tenants/v2">
                  Tenancy Version 2.0
                </NavDropdown.Item>
                
                <Divider />
                {/* <NavDropdown.Item href="/dailyReport">
                  Daily Report
                </NavDropdown.Item> */}
                <NavDropdown.Item href="/searchCustomers">
                  Search Tenants
                </NavDropdown.Item>
                <NavDropdown.Item href="/reviews/report">
                  Guest Reviews
                </NavDropdown.Item>
                
                
                
                
                {/* <NavDropdown.Item href="/prevTenants">
                  Previous Guests
                </NavDropdown.Item> */}
                {/* <NavDropdown.Item href="/tenants">
                  Current Guests
                </NavDropdown.Item> */}
                <NavDropdown.Item href="/reports">
                  Checkout Report
                </NavDropdown.Item>
                
                <NavDropdown.Item href="/inventory">
                  Inventory Report
                </NavDropdown.Item>
                <NavDropdown.Item href="/customerInquiryReport">
                  Feedback Report
                </NavDropdown.Item>

                {/* <NavDropdown.Divider />
              <NavDropdown.Item href="/repairs">Repairs</NavDropdown.Item>
              <NavDropdown.Item href="/amenities">Amenities</NavDropdown.Item> */}
                {/* <NavDropdown.Divider /> */}
              </NavDropdown>&nbsp;&nbsp;&nbsp;
              <Nav.Link href="/dashboard" style={{ color: 'white' }}>
                Dashboard
              </Nav.Link>&nbsp;&nbsp;&nbsp;
              {/* <Nav.Link href="/sms" style={{ color: 'white' }}>
                SMS
              </Nav.Link> */}
              <Nav.Link
                href="/callLogs"
                style={{ color: 'white' }}
                // onClick={(e)=>setInqueriesActivity(true)}
              >
                Inqueries
              </Nav.Link>&nbsp;&nbsp;&nbsp;
              <NavDropdown
                title={'Activities'}
                id="collapsible-nav-dropdown"
              >
                <NavDropdown.Item href="/activities">Activities Dashboard</NavDropdown.Item>
                <NavDropdown.Item href="/tasks">Activities List</NavDropdown.Item>
                <NavDropdown.Item href="/tasks/today">Today's Activities</NavDropdown.Item>
                {/* <NavDropdown.Item href="/amenities">Amenities</NavDropdown.Item> */}
              </NavDropdown>

            </Nav>
            <Nav>
            
              {/* <Nav.Link
                href="/charts"
                style={{ color: 'white' }}
              >
                Monthly Overview
              </Nav.Link> */}

              <Nav.Link href="/currentCash" style={{ color: 'white' }}>
                <FontAwesomeIcon
                  onClick={{}}
                  style={{ cursor: 'pointer' }}
                  icon={faMoneyCheckDollar}
                ></FontAwesomeIcon>{' '}
                ${currentCash}
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {inqueriesActivity && <AddInquery />}
    </>
  )
}

export default Header
